export type HealthRecordRelationshipDescriptor = {
  name: string;
  value: number;
}

export type HealthRecordAdminLockoutDescriptor = {
  name: string;
  value: number;
  code: string;
  description: string;
}

export class HealthRecordConstants {

  static ownerRelationships: HealthRecordRelationshipDescriptor[] = [
    { name: "Unknown", value: 0 },
    { name: "Parent", value: 1 },
    { name: "Legal Guardian", value: 2 },
    { name: "Survivor", value: 3 },
  ];

  static adminLockoutOptions: HealthRecordAdminLockoutDescriptor[] = [
    { name: "Unknown", value: 0, code: "?", description: "Unknown" },
    { name: "Sharing", value: 1, code: "S", description: "No sharing changes" },
    { name: "Clinic", value: 2, code: "C", description: "No clinic changes" },
    { name: "OwnerTransfer", value: 4, code: "O", description: "No owner transfer" },
    { name: "Viewing", value: 8, code: "V", description: "No viewing of health record" },
    { name: "Hide", value: 16, code: "H", description: "Hide health record" },
    { name: "Upload", value: 32, code: "U", description: "No document upload" },
  ];

  static NO_CLINIC = "(No clinic)";

}
